import { type } from '@/utils/type'

/*
//////////////////////////////////////////////////////////////////
// {{NAME}}
/////////////////////////////////////////////////////////////////
export const ADM_{{NAME}}_REQUEST =  type('ADM_{{NAME}}_REQUEST')
export const ADM_{{NAME}}_ENSURE =  type('ADM_{{NAME}}_ENSURE')

export const ADM_{{NAME}}_DETAIL_REQUEST =  type('ADM_{{NAME}}_DETAIL_REQUEST')
export const ADM_{{NAME}}_DETAIL_ENSURE =  type('ADM_{{NAME}}_DETAIL_ENSURE')

export const ADM_{{NAME}}_SAVE_REQUEST =  type('ADM_{{NAME}}_SAVE_REQUEST')
*/

//////////////////////////////////////////////////////////////////
// PARTENAIRE
/////////////////////////////////////////////////////////////////
export const ADM_PARTENAIRE_REQUEST =  type('ADM_PARTENAIRE_REQUEST')
export const ADM_PARTENAIRE_ENSURE =  type('ADM_PARTENAIRE_ENSURE')

export const ADM_PARTENAIRE_DETAIL_REQUEST =  type('ADM_PARTENAIRE_DETAIL_REQUEST')
export const ADM_PARTENAIRE_DETAIL_ENSURE =  type('ADM_PARTENAIRE_DETAIL_ENSURE')

export const ADM_PARTENAIRE_SAVE_REQUEST =  type('ADM_PARTENAIRE_SAVE_REQUEST')
export const ADM_PARTENAIRE_DELETE_REQUEST =  type('ADM_PARTENAIRE_DELETE_REQUEST')

export const ADM_PARTENAIRE_RESET_STATUS =  type('ADM_PARTENAIRE_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// FLUX
/////////////////////////////////////////////////////////////////
export const ADM_FLUX_REQUEST =  type('ADM_FLUX_REQUEST')
export const ADM_FLUX_ENSURE =  type('ADM_FLUX_ENSURE')

export const ADM_FLUX_DETAIL_REQUEST =  type('ADM_FLUX_DETAIL_REQUEST')
export const ADM_FLUX_DETAIL_ENSURE =  type('ADM_FLUX_DETAIL_ENSURE')

export const ADM_FLUX_SAVE_REQUEST =  type('ADM_FLUX_SAVE_REQUEST')
export const ADM_FLUX_DELETE_REQUEST =  type('ADM_FLUX_DELETE_REQUEST')

export const ADM_FLUX_RESET_STATUS =  type('ADM_FLUX_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// DATASOURCE
/////////////////////////////////////////////////////////////////
export const ADM_DATASOURCE_REQUEST =  type('ADM_DATASOURCE_REQUEST')
export const ADM_DATASOURCE_ENSURE =  type('ADM_DATASOURCE_ENSURE')

export const ADM_DATASOURCE_DETAIL_REQUEST =  type('ADM_DATASOURCE_DETAIL_REQUEST')
export const ADM_DATASOURCE_DETAIL_ENSURE =  type('ADM_DATASOURCE_DETAIL_ENSURE')

export const ADM_DATASOURCE_SAVE_REQUEST =  type('ADM_DATASOURCE_SAVE_REQUEST')
export const ADM_DATASOURCE_RESET_STATUS =  type('ADM_DATASOURCE_RESET_STATUS')

export const ADM_DATASOURCE_DELETE_REQUEST =  type('ADM_DATASOURCE_DELETE_REQUEST')


//////////////////////////////////////////////////////////////////
// FEEDDOWNLOAD
/////////////////////////////////////////////////////////////////
export const ADM_FEEDDOWNLOAD_REQUEST =  type('ADM_FEEDDOWNLOAD_REQUEST')
export const ADM_FEEDDOWNLOAD_ENSURE =  type('ADM_FEEDDOWNLOAD_ENSURE')

export const ADM_FEEDDOWNLOAD_DETAIL_REQUEST =  type('ADM_FEEDDOWNLOAD_DETAIL_REQUEST')
export const ADM_FEEDDOWNLOAD_DETAIL_ENSURE =  type('ADM_FEEDDOWNLOAD_DETAIL_ENSURE')

export const ADM_FEEDDOWNLOAD_SAVE_REQUEST =  type('ADM_FEEDDOWNLOAD_SAVE_REQUEST')
export const ADM_FEEDDOWNLOAD_RESET_STATUS =  type('ADM_FEEDDOWNLOAD_RESET_STATUS')

export const ADM_FEEDDOWNLOAD_DELETE_REQUEST =  type('ADM_FEEDDOWNLOAD_DELETE_REQUEST')

//////////////////////////////////////////////////////////////////
// PERSONNE
/////////////////////////////////////////////////////////////////
export const ADM_PERSONNE_REQUEST =  type('ADM_PERSONNE_REQUEST')
export const ADM_PERSONNE_ENSURE =  type('ADM_PERSONNE_ENSURE')

export const ADM_PERSONNE_DETAIL_REQUEST =  type('ADM_PERSONNE_DETAIL_REQUEST')
export const ADM_PERSONNE_DETAIL_ENSURE =  type('ADM_PERSONNE_DETAIL_ENSURE')

export const ADM_PERSONNE_SAVE_REQUEST =  type('ADM_PERSONNE_SAVE_REQUEST')
export const ADM_PERSONNE_DELETE_REQUEST =  type('ADM_PERSONNE_DELETE_REQUEST')

export const ADM_PERSONNE_RESET_STATUS =  type('ADM_PERSONNE_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// PROFIL_EXCLUSION
/////////////////////////////////////////////////////////////////
export const ADM_PROFIL_EXCLUSION_REQUEST =  type('ADM_PROFIL_EXCLUSION_REQUEST')
export const ADM_PROFIL_EXCLUSION_ENSURE =  type('ADM_PROFIL_EXCLUSION_ENSURE')

export const ADM_PROFIL_EXCLUSION_DETAIL_REQUEST =  type('ADM_PROFIL_EXCLUSION_DETAIL_REQUEST')
export const ADM_PROFIL_EXCLUSION_DETAIL_ENSURE =  type('ADM_PROFIL_EXCLUSION_DETAIL_ENSURE')

export const ADM_PROFIL_EXCLUSION_SAVE_REQUEST =  type('ADM_PROFIL_EXCLUSION_SAVE_REQUEST')
export const ADM_PROFIL_EXCLUSION_DELETE_REQUEST =  type('ADM_PROFIL_EXCLUSION_DELETE_REQUEST')

export const ADM_PROFIL_EXCLUSION_RESET_STATUS =  type('ADM_PROFIL_EXCLUSION_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// GROUP_CARAC
/////////////////////////////////////////////////////////////////
export const ADM_GROUP_CARAC_REQUEST =  type('ADM_GROUP_CARAC_REQUEST')
export const ADM_GROUP_CARAC_ENSURE =  type('ADM_GROUP_CARAC_ENSURE')

export const ADM_GROUP_CARAC_DETAIL_REQUEST =  type('ADM_GROUP_CARAC_DETAIL_REQUEST')
export const ADM_GROUP_CARAC_DETAIL_ENSURE =  type('ADM_GROUP_CARAC_DETAIL_ENSURE')

export const ADM_GROUP_CARAC_SAVE_REQUEST =  type('ADM_GROUP_CARAC_SAVE_REQUEST')
export const ADM_GROUP_CARAC_DELETE_REQUEST =  type('ADM_GROUP_CARAC_DELETE_REQUEST')

export const ADM_GROUP_CARAC_RESET_STATUS =  type('ADM_GROUP_CARAC_RESET_STATUS')


export const ADM_CARAC_REQUEST =  type('ADM_CARAC_REQUEST')
export const ADM_CARAC_ENSURE =  type('ADM_CARAC_ENSURE')